export default [
  {
    id: 'unity',
    text: 'Unidade',
    title: 'Unidade operacional onde está alocado',
    checked: false
  },
  {
    id: 'number',
    text: 'Número',
    title: 'Número do grupo, operador, cliente, ...',
    checked: true
  },
  {
    id: 'name',
    text: 'Nome',
    title: 'Nome do grupo, departamento, agente, etc.',
    checked: true
  },
  {
    id: 'initials',
    text: 'Sigla',
    title: 'Sigla do grupo de atendimento',
    checked: true
  },
  {
    id: 'internal',
    text: 'Internas',
    title:
      'Quantidade de ligações internas do operador, grupo, departamento, etc',
    checked: false
  },
  {
    id: 'pctInternal',
    text: '% internas',
    title:
      'Percentual de ligações internas do operador, grupo, departamento, etc',
    checked: false
  },
  {
    id: 'received',
    text: 'Recebidas',
    title: 'Total de registros de recebimento (ligação)',
    checked: true
  },
  {
    id: 'directReceived',
    text: 'Recebidas direto',
    title:
      'Chamadas recebidas diretamente por este destino sem transbordo, transferencia, captura, etc.',
    checked: false
  },
  {
    id: 'answered',
    text: 'Atendidas',
    title: 'Total de registros de atendimento (ligação)',
    checked: true
  },
  {
    id: 'answeredRecall',
    text: 'Atendidas rechamada',
    title: 'Ligações atendidas depois de tentar transferir sem sucesso',
    checked: false
  },
  {
    id: 'answeredNormal',
    text: 'Atendidas sem captura',
    title: 'Ligações atendidas normalmente sem captura',
    checked: false
  },
  {
    id: 'answeredOverflow',
    text: 'Atendidas pós-transbordo',
    title:
      'Ligações atendidas após serem transbordadas. Caso tenha transbordado para outro grupo, Não contabiliza como atendimento para este grupo!',
    checked: false
  },
  {
    id: 'callPickup',
    text: 'Capturadas',
    title: 'Ligações atendidas por captura',
    checked: true
  },
  {
    id: 'pctAnswered',
    text: '% atendidas',
    title: 'Percentual de registros de atendimento',
    checked: false
  },
  {
    id: 'ttanswer',
    text: 'T. atendimento(P)',
    title:
      'Tempo de atendimento deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'avganswer',
    text: 'TM. atendimento(P)',
    title:
      'Tempo médio de atendimento deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'maxanswer',
    text: 'Max. atendimento(P)',
    title:
      'Maior tempo de atendimento deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'minanswer',
    text: 'Mix. atendimento(P)',
    title:
      'Menor tempo de atendimento deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'ttwait',
    text: 'T.espera',
    title:
      'Soma dos tempos de espera deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'avgwait',
    text: 'TM.espera',
    title: 'Tempo médio de espera deste grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'maxwait',
    text: 'Max. espera',
    title: 'Maior tempo de espera deste grupo, departamento, etc.',
    checked: false
  },
  {
    id: 'minwait',
    text: 'Min. espera',
    title: 'Menor tempo de espera deste grupo, departamento, etc.',
    checked: false
  },
  {
    id: 'lost',
    text: 'Perdidas',
    title: 'Total de chamadas perdidas',
    checked: true
  },
  {
    id: 'pctLost',
    text: '% perdidas',
    title: 'Percentual de chamadas perdidas',
    checked: false
  },
  {
    id: 'ttLost',
    text: 'T.Perdidas',
    title:
      'Soma do tempo de espera de chamadas perdidas pelo grupo/departamento',
    checked: false
  },
  {
    id: 'avgLost',
    text: 'TM.Perdidas',
    title: 'Tempo médio de espera de chamadas perdidas pelo grupo/departamento',
    checked: false
  },
  {
    id: 'maxLost',
    text: 'Max.Perdida',
    title: 'Maior tempo de espera de chamada perdida pelo grupo/departamento',
    checked: false
  },
  {
    id: 'minLost',
    text: 'Min.Perdida',
    title: 'Menor tempo de espera de chamada perdida pelo grupo/departamento',
    checked: false
  },
  {
    id: 'grpbusy',
    text: 'Grupo ocupado',
    title:
      'chamadas que foram entregues ao grupo ocupado (não haviam agentes logados)',
    checked: false
  },
  {
    id: 'leaved',
    text: 'Abandonadas',
    title: 'Total de registros de abandono em fila',
    checked: true
  },
  {
    id: 'pctLeaved',
    text: '% abandonadas',
    title: 'Percentual de registros de abandono em fila',
    checked: false
  },
  {
    id: 'ttLeaved',
    text: 'T. abandonos',
    title:
      'Soma do tempo de espera de chamadas abandonadas em fila pelo cliente',
    checked: false
  },
  {
    id: 'avgLeaved',
    text: 'TM. abandono',
    title:
      'Tempo médio de espera de chamadas abandonadas em fila pelos clientes',
    checked: false
  },
  {
    id: 'maxLeaved',
    text: 'Max. abandono',
    title: 'Maior tempo de espera de chamada abandonada em fila pelo cliente',
    checked: false
  },
  {
    id: 'minLeaved',
    text: 'Min. abandono',
    title: 'Menor tempo de espera de chamada abandonada em fila pelo cliente',
    checked: false
  },
  {
    id: 'notAnswered',
    text: 'Não atendidas',
    title: 'Total de registros de não atendidas pelos operadores',
    checked: true
  },
  {
    id: 'notAnsweredAndOverflowed',
    text: 'Não atd. e Transbordadas',
    title:
      'Total de chamadas que foram transbordadas pelo PABX após não serem atendidas pelos operadores',
    checked: false
  },
  {
    id: 'pctNotAnswered',
    text: '% não atendidas',
    title: 'Percentual de registros de não atendidas pelos operadores',
    checked: false
  },
  {
    id: 'ttNotAnswered',
    text: 'T. não atendidas',
    title: 'Soma do tempo de espera de chamadas não atendidas pelos operadores',
    checked: false
  },
  {
    id: 'avgNotAnswered',
    text: 'TM.NAtendida',
    title: 'Tempo médio de espera de chamadas não atendidas pelo operador',
    checked: false
  },
  {
    id: 'maxNotAnswered',
    text: 'Max. não atendida',
    title: 'Maior tempo de espera de chamada não atendida pelo operador',
    checked: false
  },
  {
    id: 'minNotAnswered',
    text: 'Min. não atendida',
    title: 'Menor tempo de espera de chamada não atendida pelo operador',
    checked: false
  },
  {
    id: 'ttNotAnsweredRing',
    text: 'TNAtendidas ring',
    title: 'Soma do tempo de ring de chamadas não atendidas pelos operadores',
    checked: false
  },
  {
    id: 'avgNotAnsweredRing',
    text: 'TM Ring NAtendidas',
    title: 'Maior tempo de ring de chamada não atendida pelo operador',
    checked: false
  },
  {
    id: 'maxNotAnsweredRing',
    text: 'Max Ring NAtendida',
    title: 'Maior tempo de ring de chamada não atendida pelo operador',
    checked: false
  },
  {
    id: 'minNotAnsweredRing',
    text: 'Min Ring NAtendida',
    title: 'Menor tempo de ring de chamada não atendida pelo operador',
    checked: false
  },
  {
    id: 'queued',
    text: 'Fila(P)',
    title: 'Total de ligações que passaram pela fila no dia',
    checked: false
  },
  {
    id: 'ttqueued',
    text: 'T.fila(P)',
    title: 'Soma do tempo de espera em fila no periodo',
    checked: false
  },
  {
    id: 'avgqueued',
    text: 'TM.fila(P)',
    title: 'Tempo médio de espera em fila no periodo',
    checked: false
  },
  {
    id: 'maxqueued',
    text: 'Max.fila(P)',
    title: 'Maior tempo de espera em fila no periodo',
    checked: false
  },
  {
    id: 'minqueued',
    text: 'Min.fila(P)',
    title: 'Menor tempo de espera em fila no periodo',
    checked: false
  },
  {
    id: 'hqueued',
    text: 'Maior fila',
    title: 'Maior fila do periodo (ligações enfileiradas ao mesmo tempo)',
    checked: false
  },
  {
    id: 'ttring',
    text: 'T. ring(P)',
    title: 'Tempo de espera em ring deste operador, grupo, departamento, etc.',
    checked: false
  },
  {
    id: 'avgring',
    text: 'TM. ring(P)',
    title:
      'Tempo médio de espera em ring deste operador, grupo, departamento, etc.',
    checked: false
  },
  {
    id: 'maxring',
    text: 'Max. ring(P)',
    title:
      'Maior tempo de espera em ring deste operador, grupo, departamento, etc.',
    checked: false
  },
  {
    id: 'minring',
    text: 'Min. ring(P)',
    title:
      'Menor tempo de espera em ring deste operador, grupo, departamento, etc.',
    checked: false
  },
  {
    id: 'incoming',
    text: 'Entrada',
    title:
      'Quantidade de ligações que vieram de origem externa para o operador, grupo, departamento, etc',
    checked: false
  },
  {
    id: 'pctIncoming',
    text: '% entrada',
    title:
      'Percentual de ligações que vieram de origem externa para este operador, grupo, departamento, etc',
    checked: false
  },
  {
    id: 'overflow',
    text: 'Rcb. transbordo',
    title:
      'Ligações que foram transbordadas automáticamente (pelo PABX) para este operador, grupo, departamento, etc',
    checked: false
  },
  {
    id: 'overflowed',
    text: 'Transbordadas',
    title:
      'Ligações que foram transbordadas automaticamente (pelo PABX) deste este operador, grupo, departamento, etc. Para outro destino',
    checked: false
  },
  {
    id: 'transfer',
    text: 'Rcb. transferencia',
    title:
      'Ligações que foram transferidas para este operador, grupo, departamento, etc',
    checked: false
  },
  {
    id: 'transferred',
    text: 'Transferidas',
    title:
      'Ligações que foram transferidas por este operador, grupo, departamento, etc. Para outro destino',
    checked: false
  },
  {
    id: 'recall',
    text: 'Rechamadas',
    title:
      'Chamadas que voltaram a tocar neste operador, grupo, etc. Após espera ou transferencia (no período)',
    checked: false
  },
  {
    id: 'endByCalling',
    text: 'Fim chamador',
    title: 'Chamadas que foram desligadas por quem originou a chamada',
    checked: false
  },
  {
    id: 'endByCalled',
    text: 'Fim chamado',
    title: 'Chamadas que foram desligadas por quem recebeu a chamada',
    checked: false
  },
  {
    id: 'delivered',
    text: 'Entregues',
    title:
      'Chamadas que foram recebidas pelo destino final agente, cliente, etc.',
    checked: false
  },
  {
    id: 'helded',
    text: 'Consultas',
    title: 'Chamadas colocadas em espera pelo operador, grupo, etc. No período',
    checked: false
  },
  {
    id: 'tthelded',
    text: 'T. consulta(P)',
    title:
      'Tempo de consulta deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'avghelded',
    text: 'TM. consulta(P)',
    title:
      'Tempo médio de consulta deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'maxhelded',
    text: 'Max. consulta(P)',
    title:
      'Maior tempo de consulta deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'minhelded',
    text: 'Min. consulta(P)',
    title:
      'Menor tempo de consulta deste operador, grupo, departamento, etc. No período',
    checked: false
  },
  {
    id: 'scores',
    text: 'Chamadas avaliadas',
    title: 'Quantidade de chamadas avalidas pelos clientes',
    checked: false
  },
  {
    id: 'score',
    text: 'Nota total',
    title: 'Soma das notas de chamadas avalidas pelos clientes',
    checked: false
  },
  {
    id: 'avgscore',
    text: 'Nota média',
    title: 'Média das notas recebidas',
    checked: false
  },
  {
    id: 'minscore',
    text: 'Menor Nota',
    title: 'Menor nota recebida',
    checked: false
  },
  {
    id: 'maxscore',
    text: 'Maior Nota',
    title: 'Maior nota recebida',
    checked: false
  }
];
